module.exports = __webpack_public_path__ + "themes/mf/img/prize-9@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-9@2x.png
// module id = 103
// module chunks = 3